module.exports = {
    hide:'Hide current column',
    showall:'Expand all columns',
    showatone:'Keep at least one column',
    runReport:'Run Report',
    reset:'Reset',
    Comfirm:'Comfirm',
    today: 'Today',
    yesterday:'Yesterday',
    last7Days:'Last 7 Days',
    last30Days: 'Last 30 Days',
    last60Days: 'Last 60 Days',
    last90Days: 'Last 90 Days',
    thisMonth:'This Month',
    status:'Status',
    addNew: 'Add New',
    history:'History case',
    pkg:'App ID',
    add:'Add',
    edit: 'Edit',
    all:'All',
    advname:'Adv Name',
    trackingSystem:'Tracking System',
    advGroup:'Adv Group',
    coop:'Adv Cooperation Type',
    cpa:'CPA',
    cpi:'CPI',
    createADV:'Create New Adv',
    resetPWD:'Reset Password',
    image:'Image',
    official:'Auto',
    fileLarge:'The uploaded file exceeds 500 MB',
    repeathave:'The dimension you have selected is duplicated. Please set it again.',
    nolimits:'The process have closed,you can not operate it',
    noofficial:'Manual',
    tokoltrack:'You have new process updates, please check in time',
    video:'Video',
    shengcheng:'please comfirm to start process?',
    jieshu:'please comfirm to reject the kol?',
    delete: 'Delete',
    refresh:'Update Data',
    sorry:'The corresponding connection to the KOL platform has not been obtained temporary. Please update the data and try again!',
    UploadSuccess:'Upload Success',
    siteId:'Campaign',
    launch: 'Launch',
    fileUP:'The format of your uploaded file does not match the system, please upload PDF',
    unLaunch: 'UnLaunch',
    launched: 'Launched',
    noAuthority:'You do not have the authority to operate!',
    pia:'Please input action',
    pim:'Please input method',
    pimn:'Please input module name',
    picn:'Please input class name',
    psr:'Please select role',
    changeSuccess:'Change success',
    searchaction:'Search action',
    className:'Class Name',
    moduleName:'Module Name',
    method:'Method',
    action:'Action',
    no:'No',
    authority:'Authority ID',
    No:'No',

    launchSuccess:'launch success',
    clearFilters: 'clear filters',
    total:'Total',
    completeIfo:'please complete launch info',
    leastOne:'Please select at least one data.',
    items:'Items',
    changePassword: 'Change Password',
    adds:'Add',
    noprice:'price，',
    isEmpty:'have to fill in.',
    logout: 'Log Out',
    pptpdf:'The format of your uploaded file does not match the system, please upload the file format of PPT, PDF, Word or Excel.',
    pdf:'The format of your uploaded file does not match the system, please upload the file format of PDF.',
    formattips:'The format of your uploaded file does not match the system',
    deleteSuccess:'Delete success',
    addSuccess:'Add Success',
    notime:'If reservation price have been filled in , the time range have to fill in',
    nomediasource:'media source，',
    editSuccess:'Edit Success',
    haventchoose:'product permissions are not configured',
    nocountry:'country ,',
    deletekol:'Clicking OK will delete this KOL record. Are you sure you want to continue deleting it?',
    noeventName:'event name ,',
    event_method:'event method',
    nocampaign:'campaign,',
    timewrong:'The reservation start time cannot be less than or equal to the current time',
    costseeting:'Cost setting is a required option, please fill in the price of each media source',
    checkfail:'advertiser is exist in setting list',
    noexist:'advertiser is not exist',
    HelpCenter:'Help Center',
    HelpCenterView:'Help Center',
    whatsnew: `What's New`,
    notifications: 'Notifications',
    Notification:'Notification',
    top5MediaSource: 'TOP 5 Media Source',
    top5App: 'Top 5 Apps',
    country: 'Country',
    videolink:'Video Link',
    advertiser: 'Advertiser',
    Aff_cost:'Affiliate Cost',
    childs:'Video Link Detail Data',
    caf:'Clear all filters',
    cost: 'Adv Cost',
    search: 'Search',
    dateRange: 'Date Range',
    platform: 'Platform',
    language: 'Language',
    setting: 'Setting',
    changePassword: 'Change Password',
    changePasswordTips1: 'If you have any problem,',
    changePasswordTips2: 'please feel free to contect your account manager.',
    originalPassword: 'Original Password',
    newPassword: 'New Password',
    enterNewPasswordAgain: 'Enter New Password Again',
    save: 'Save',
    coludBeStronger: 'Colud be stronger',
    strongPassword: 'Strong password',
    pleaseEnterTheOriginPassword: 'Please enter the origin password.',
    pleaseEnterThePassword: 'Please enter the password.',
    enterNewPasswordAgainTips: 'Please enter new password again.',
    enterSamePassword: 'Password you entered must be the same.',
    settingYourPassword: 'Setting your password',
    settingYourPasswordTips1: 'Finally You’re Comming!',
    settingYourPasswordTips2: 'For your account safty, plesae setting password.',
    later: 'later',
    PasswordSettingSuccess1: 'Password Setting',
    PasswordSettingSuccess2: 'Successful！',
    logbackWithNewPasswordTips1: 'your account will log out automatically,',
    logbackWithNewPasswordTips2: 'please log back with new password.',
    ok: 'OK',
    clcick:'Click me to read your closing report',
    logback: 'Log back',
    upload: 'Upload',
    confirm: 'Confirm',
    cancel: 'Cancel',
    confirmTips1: 'Delete confirm',
    zhixing:'Execute confirm',
    okconfirm:'Agree confirm',
    rejconfirm:'Reject confirm',
    confirmTips2: 'Are you sure you want to delete the items?',
    launchTips1: 'Launch confirm',
    launchTips2: 'Once launched, clients will read these updated',
    launchTips3: 'reports.',
    replace: 'Replace',
    allSelect: 'All Selected',
    unread: 'Unread',
    allUpdate: 'All Update',
    Input:'Input ',
    togray:'This index cannot be displayed due to calculation rule restrictions',
    Selects:'Select',
    nodata:'No data',
    inputSearchText: 'input search text',
    date: 'Date',
    exportReport: 'Export Report',
    operate: 'Operate',
    addbefore:'You have the right to support the creation of 8 derivative accounts, if you want to apply for additional, please contact your Account Manager',
    addbeforenotice:'You have no permission to create more accounts. If you have other questions, please contact the YM counterpart',
    pleaseHoldon: 'Trying to load, please wait...',
    move:'move',
    Apply:'Apply',
    upOne:'Move up',
    downOne:' Move down',
    TopOne:'To top',
    Today:'Today',
    Yesterday:'Yesterday',
    Last7Days:'Last 7 Days',
    LastMonth:'Last Month',
    ThisMonth:'This Month',
    CustomRange:'CustomRange',
    deleteSure:'Sure to delete?',
    Campaign:'Campaign',
    Cost:'Cost',
    ViewCounts:'View Counts',
    formatimg:'The filesize of your uploaded file does not match the system, please upload the format of Image',
    accountOne:'Account have been chosen,please choose another one!',
    modulechosens:'This moduleType is choosen in Head Of Account',
    emptymodule:'Module can not be empty,at least have one choice',
    allread:'mark all as read',
    allreadtitle:'Mark all as read',
    Yes:'Yes',
    dats:'Date',
    readsure:'All notifications in the notification bar will be updated to the read status. Are you sure to continue?',
    haveit:'The mediasource under this piknamge already exists. Please modify it and save it again',
    limitDDateRangeTip: 'Up to 3 months of queries are supported here',
    tooltipYes: 'Yes',
    tooltipNo: 'No',
    uf:'Update Fail',
    deletefail:'Delete Fail',
    noconversionType:'conversion type,',
    retargeting: 'Retargeting',
    event: 'Event',
    settingStatusInfo: "After selecting pause, the APP's data will be paused from updating. Are you sure you want to pause?",
    emailFormatwrong:'The email is not formatted correctly',
    statschange:'Are you sure about the modification status?',
    pwsworng:'Please fill in the correct username (email)'
  
}



// WEBPACK FOOTER //
// ./src/i18n/modules/public/en.js